import React, { useState } from "react";
import SideBar from "../SideBar/sideBar";
import { useNavigate } from "react-router-dom";
import '../../index.css';
import LockIcon from '@mui/icons-material/Lock';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Sendmail } from "../api/Service";
import Modal from 'react-modal';
import { MdLock } from "react-icons/md";

const SendMail = () => {
    // const PlanTypeName = localStorage.getItem('PlanTypeName');
    const navigate = useNavigate();
    const FirstName = localStorage.getItem('firstName') || '';
    const LastName = localStorage.getItem('lastName') || '';
    const initials = `${FirstName.charAt(0)}${LastName.charAt(0)}`;
    const PlanTypeName = localStorage.getItem('PlanTypeName')
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [next, setNext] = useState(1)
    const [letterDiscription, setLetterDiscription] = useState('')
    const [DisputeLetter, setDisputeLetter] = useState('')
    const [error, setError] = useState(null)
    const [RecieverAddress, setRecieverAddress] = useState({
        firstName: '',
        lastName: '',
        companyName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        provinceOrState: '',
        email: '',

    }||'')
    const [SenderAddress, setSenderAddress] = useState({
        firstName: '',
        lastName: '',
        companyName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        provinceOrState: '',
        email: '',

    }||'')
    const handleRecieverChange = (e) => {
        const { name, value } = e.target;
        setRecieverAddress((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSenderChange = (e) => {
        const { name, value } = e.target;
        setSenderAddress((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleNext = () => {
        if (!SenderAddress.firstName || !SenderAddress.lastName || !SenderAddress.addressLine1 || !SenderAddress.addressLine2 || !SenderAddress.companyName || !SenderAddress.email || !SenderAddress.city || !SenderAddress.provinceOrState || !RecieverAddress.firstName || !RecieverAddress.lastName || !RecieverAddress.addressLine1 || !RecieverAddress.addressLine2 || !RecieverAddress.companyName || !RecieverAddress.email || !RecieverAddress.city || !RecieverAddress.provinceOrState) {
            setError('Please fill all the fields')
        } else {
            setError(null)
            setNext(true)
        }
    }
    const handleBack = () => {
        console.log(next, 'backkk')
        setNext(1)
    }


    const handleSubmit = async (e) => {

        setLoading(true);
        e.preventDefault();
        const data = {
            RecevierAddress: {
                firstName: RecieverAddress.firstName,
                lastName: RecieverAddress.lastName,
                companyName: RecieverAddress.companyName,
                addressLine1: RecieverAddress.addressLine1,
                addressLine2: RecieverAddress.addressLine2,
                city: RecieverAddress.city,
                provinceOrState: RecieverAddress.provinceOrState,
                email: RecieverAddress.email
            },
            SenderAddress: {
                firstName: SenderAddress.firstName,
                lastName: SenderAddress.lastName,
                companyName: SenderAddress.companyName,
                addressLine1: SenderAddress.addressLine1,
                addressLine2: SenderAddress.addressLine2,
                city: SenderAddress.city,
                provinceOrState: SenderAddress.provinceOrState,
                email: SenderAddress.email,

            },
            Letterdiscription: letterDiscription,
            disputeLetter: DisputeLetter

        }
        if (!DisputeLetter || !letterDiscription) {
            setError('Please fill all the fields')
        } else {
            setError(null)
            try {
                const response = await Sendmail(data);
                console.log(response)
                if (response.status === 200) {
                    setIsModalOpen(true)
                }
                setLoading(false)
            } catch (error) {
                console.log(error)
            }
        }


    }
    const closeModal = () => {
        setIsModalOpen(false);
        setRecieverAddress('')
        setSenderAddress('')
        setDisputeLetter('')
        setLetterDiscription('')
        setNext(1)
    };

    return (<div className="flex h-100% bg-[#121212]">
        <SideBar />
        <main className="flex-1 overflow-y-auto p-6 min-h-screen">
        <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">Send Direct Mail</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {PlanTypeName?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>
            {/* <div className="videoyou bg-[#1E1E1E] p-4 sm:p-6 rounded-lg mx-auto mb-8" style={{ height: "625px", maxWidth: "850px" }}>
                <div className="relative h-full">
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/XSOmVb7nCTI"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Video"
                        className="absolute inset-0 rounded-lg"
                    ></iframe>

                </div>
            </div> */}
            <div>
                <form className="space-y-4 bg-[#2d2c2c] p-4">
                    {/* Reciever Address Section */}
                    {error && <p className="text-sm mt-1 flex items-center justify-start gap-[8px] pl-3 rounded-sm bg-pink-100 h-10">{error}</p>}
                    {next === 1 ? (<><h1 className="text-xl font-bold text-white">Receiver Address</h1>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input
                                type="text"
                                name="firstName"
                                placeholder="First Name"
                                value={RecieverAddress.firstName}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="lastName"
                                placeholder="Last Name"
                                value={RecieverAddress.lastName}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="companyName"
                                placeholder="Company Name"
                                value={RecieverAddress.companyName}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="addressLine1"
                                placeholder="Address Line1"
                                value={RecieverAddress.addressLine1}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="addressLine2"
                                placeholder="Address Line2"
                                value={RecieverAddress.addressLine2}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="city"
                                placeholder="City"
                                value={RecieverAddress.city}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="provinceOrState"
                                placeholder="Province Or State"
                                value={RecieverAddress.provinceOrState}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={RecieverAddress.email}
                                onChange={handleRecieverChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                        </div>

                        {/* Sender Address Section */}
                        <h1 className="text-xl font-bold text-white mt-6">Sender Address</h1>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input
                                type="text"
                                name="firstName"
                                placeholder="First Name"
                                value={SenderAddress.firstName}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="lastName"
                                placeholder="Last Name"
                                value={SenderAddress.lastName}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="companyName"
                                placeholder="Company Name"
                                value={SenderAddress.companyName}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="addressLine1"
                                placeholder="Address Line1"
                                value={SenderAddress.addressLine1}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="addressLine2"
                                placeholder="Address Line2"
                                value={SenderAddress.addressLine2}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="city"
                                placeholder="City"
                                value={SenderAddress.city}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="text"
                                name="provinceOrState"
                                placeholder="Province Or State"
                                value={SenderAddress.provinceOrState}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={SenderAddress.email}
                                onChange={handleSenderChange}
                                className="bg-[#2A2A2A] rounded p-2 text-white"
                                required
                            />
                        </div>
{(PlanTypeName?.includes('Lifetime Access')||PlanTypeName?.includes("Elite Plan"))?(<div className="flex justify-center space-x-4 mt-4">
                            <button
                                type="button"
                                className="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded"
                                onClick={handleNext}
                            >
                                Next 
                            </button>
                        </div>):( <div className="flex justify-center space-x-4 mt-4">
                            <button
                                type="button"
                                className="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded"
                                onClick={()=>navigate('/app/subscription')}
                            >
                                Next<LockIcon className="mr-2"/>
                            </button>
                        </div>)}
                       </>)
                        :
                        (<>
                            <label
                                for="message"
                                className=" text-sm font-semibold text-white dark:text-white"
                            >
                                Enter Letter Discription
                            </label>
                            <input
                                type="text"
                                name="LetterDiscription"
                                placeholder="Letter Discription"
                                value={letterDiscription}
                                onChange={(e) => setLetterDiscription(e.target.value)}
                                className="bg-[#2A2A2A] rounded p-2 text-white w-full mb-5"
                                required
                            />

                            <label
                                htmlFor="message"
                                className="text-sm font-semibold text-white dark:text-white"
                            >
                                Enter Letter
                            </label>

                            <ReactQuill
                                value={DisputeLetter}
                                onChange={setDisputeLetter}
                                theme="snow"
                                placeholder=""
                                className="p-2.5 w-full text-sm min-h-[400px] text-white bg-gray-900 rounded-lg border focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                            <div className="flex justify-center space-x-4 mt-4">
                                <button
                                    type="button"
                                    className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded"
                                    onClick={handleBack}

                                >
                                    Go Back
                                </button>
                            
                                <button
                                    type="submit"
                                    className="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded"
                                    onClick={handleSubmit}
                                >
                                    {loading ? 'Sending Mail...' : 'Submit'}
                                </button>
                            </div>
                        </>)}

                </form>
                {/* Modal */}
                <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    className="fixed inset-0 flex items-center justify-center z-50"
                    overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
                >
                    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                        <h2 className="text-2xl font-semibold text-center mb-4">Mail Sent Successfully</h2>
                        <p className="text-center mb-6">Your mail has been sent successfully!</p>
                        <div className="flex justify-center">
                            <button
                                onClick={closeModal}
                                className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        </main>
    </div>)
}

export default SendMail;